import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgMeasureArea = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M6 3H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM18 16h2V5a1 1 0 0 0-1-1H8.5v2H18v10ZM6 8H4v11a1 1 0 0 0 1 1h11v-2H6V8ZM20 17h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z" />
  )
export default SvgMeasureArea
